import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = [
    'birthdayTrigger',
    'peselWrapper',
    'birthdaySection',
    'onlyPeselValidationInput',
    'root',
    'oneParentWrapper',
    'basicToggleableSection',
  ];

  showBirthday() {
    this.birthdayTriggerTarget.classList.add('clicked');
    this.peselWrapperTarget.classList.remove('field_with_errors');
    let pesel_error = this.peselWrapperTarget.querySelector('.error');
    if (pesel_error) {
      pesel_error.parentNode.removeChild(pesel_error);
    }
    this.onlyPeselValidationInputTarget.value = false;
    $(this.birthdaySectionTarget).slideDown(() => {
      this.birthdaySectionTarget.classList.add('opened');
      this.birthdaySectionTarget.removeAttribute('style');
    });
  }

  toggleOnlyOneParent(event) {
    if (event.target.checked) {
      this.basicToggleableSectionTargets.forEach((item) => {
        item.classList.remove('opened');
      });
      this.birthdaySectionTarget.classList.remove('opened');
      this.oneParentWrapperTarget.classList.add('bold_label');
    } else {
      this.basicToggleableSectionTargets.forEach((item) => {
        item.classList.add('opened');
      });
      if (this.onlyPeselValidationInputTarget.value.toLowerCase() === 'false') {
        this.birthdaySectionTarget.classList.add('opened');
      }
      this.oneParentWrapperTarget.classList.remove('bold_label');
    }
  }
}
